/* eslint-disable no-await-in-loop */
import AsyncEvaluator from '../AsyncEvaluator.js'

/**
 * Defines a satisfies class that can be tested, yielding either true, false, or null
 */
export default class LogicEvaluator extends AsyncEvaluator {
  
  static TYPE = 'condition.Logical'

  constructor( model, factory ) {
    super( model, factory )
    this.children = this.model.conditions.map( ( condition ) => {
      const r = factory.create( condition, factory )
      if ( r == null ) {
        throw Error( `No AsyncEvaluator available for condition type: ${condition?.type}` )
      }
      return r
    } )
  }

  /**
  * Determines whether targets satisfy the model given the context
  * @param {*} context The context with which the satisfies method is to be executed
  * @return {Promise} returns a promise that called all of the sub satisfies 
  */
  async satisfies( context ) {
    const cnds = this.children
    const count = cnds.length

    switch ( this.model.operator ) {
      case 'and': {
        let hasUnknown = false
        for ( let n = 0; n < count; n++ ) {
          const cr = await cnds[n].satisfies( context )
          if ( cr === false ) {
            return false
          } 
          hasUnknown = hasUnknown || cr == null
        }
        return hasUnknown ? null : true
      }

      case 'or': {
        let hasUnknown = false
        for ( let n = 0; n < count; n++ ) {
          const cr = await cnds[n].satisfies( context )
          if ( cr === true ) {
            return true
          } 
          hasUnknown = hasUnknown || cr == null
        }
        return hasUnknown ? null : false
      }

      case 'xor': {
        let hasUnknown = false
        let total = 0
        for ( let n = 0; n < count; n++ ) {
          const cr = await cnds[n].satisfies( context )
          if ( cr === true ) {
            total++
            if ( total > 1 ) {
              return false
            }
          } 
          hasUnknown = hasUnknown || cr == null
        }
        return hasUnknown ? null : total === 1
      }

      case 'nor': {
        let hasUnknown = false
        for ( let n = 0; n < count; n++ ) {
          const cr = await cnds[n].satisfies( context )
          if ( cr === true ) {
            return false
          } 
          hasUnknown = hasUnknown || cr == null
        }
        return hasUnknown ? null : true
      }

      case 'nand': {
        let hasUnknown = false
        for ( let n = 0; n < count; n++ ) {
          const cr = await cnds[n].satisfies( context )
          if ( cr === false ) {
            return true
          } 
          hasUnknown = hasUnknown || cr == null
        }
        return hasUnknown ? null : false
      }
      case 'xnor': {
        let f = 0
        let t = 0
        for ( let n = 0; n < count; n++ ) {
          const cr = await cnds[n].satisfies( context )
          if ( cr == null ) {
            return null
          }
          if ( cr === false ) {
            f++
            if ( t > 0 ) {
              return false
            }
          } else if ( cr === true ) {
            t++
            if ( f > 0 ) {
              return false
            }
          }
        }
        return true
      }

      default:
        return null
    }
  }
}
